import React, { useState } from "react";
import CardGrid from "../components/CardGrid";
import CreateItemModal from "../components/CreateItemModal";
import CustomFooter from "../components/CustomFooter";
import CustomNavbar from "../components/CustomNavbar";
import { useAuth } from "../contexts/AuthContext";

export default function DashboardPrivate() {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [showView, setShowView] = useState(false);

  return (
    <div>
      <CustomNavbar
        loading={loading}
        setLoading={setLoading}
        setShowCreate={setShowCreate}
        isPrivate={true}
      />

      <CardGrid
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        showView={showView}
        setShowView={setShowView}
        uid={currentUser.uid}
        category="None"
        isPrivate={true}
      />

      <CreateItemModal
        showCreate={showCreate}
        setShowCreate={setShowCreate}
        loading={loading}
        setLoading={setLoading}
      />

      <CustomFooter />
    </div>
  );
}
